var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    y: 0.978638,
    width: 72,
    height: 72,
    rx: 16,
    fill: "#21A828"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 62C49.8071 62 61 50.8071 61 37C61 23.1929 49.8071 12 36 12C22.1929 12 11 23.1929 11 37C11 50.8071 22.1929 62 36 62Z",
    fill: "#21A828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6118 48.2776L42.4667 61.1325C53.1134 58.2934 60.9998 48.5931 60.9998 37V36.2902L50.9052 26.9842L29.6118 48.2776Z",
    fill: "#05850B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6308 42.5994C37.7349 43.7035 37.7349 45.5962 36.6308 46.7003L34.3437 48.9874C33.2396 50.0915 31.3469 50.0915 30.2428 48.9874L20.227 38.8928C19.1229 37.7887 19.1229 35.8959 20.227 34.7918L22.5141 32.5047C23.6182 31.4006 25.5109 31.4006 26.615 32.5047L36.6308 42.5994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3848 25.1704C46.4889 24.0663 48.3816 24.0663 49.4857 25.1704L51.7728 27.4574C52.8769 28.5615 52.8769 30.4543 51.7728 31.5584L34.4226 48.8297C33.3185 49.9338 31.4258 49.9338 30.3217 48.8297L28.0346 46.5426C26.9305 45.4385 26.9305 43.5457 28.0346 42.4416L45.3848 25.1704Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(11 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.322792f22db5596b8c8936e9095b986b.svg";
export { ForwardRef as ReactComponent };